export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_LOADING = "SET_LOADING";
export const SET_ORIGINAL_WORD = "SET_ORIGINAL_WORD";
export const SET_SUGGESTIONS = "SET_SUGGESTIONS";
export const SET_SUGGESTIONS_POSITION = "SET_SUGGESTIONS_POSITION";
export const SET_SUGGESTIONS_VISIBILITY = "SET_SUGGESTIONS_VISIBILITY";
